module.exports = __webpack_public_path__ + "assets/img/principleImgCN.7cffdc56.png";